import styled from 'styled-components';

export const StyledSwiper = styled.div`
  .swiper-button-next,
  .swiper-button-prev {
    color: #585959; /* 원하는 색상으로 변경 */
    opacity: 0.7; /* 필요시 투명도 조절 */
  }
`;
